import { on, fire } from 'delegated-events';
import helpers from './helpers.js';

export default (function () {
  return {
    init() {
      const pagedTabs = document.querySelectorAll('.js-paged-tabs');
      if (pagedTabs.length) {
        [...pagedTabs].forEach((tabsSet) => {
          const tabs = tabsSet.querySelectorAll('.paged-tabs__tab');

          function updateNav(i) {
            const buttons = tabsSet.querySelectorAll('.js-tabs-next, .js-tabs-prev');
            const prev = tabsSet.querySelector('.js-tabs-prev');
            const next = tabsSet.querySelector('.js-tabs-next');

            helpers.removeClass(buttons, 'is-disabled');
            if (i === 0) prev.classList.add('is-disabled');
            if (i === tabs.length - 1) next.classList.add('is-disabled');
          }

          function goto(i) {
            if (i >= tabs.length || i < 0) {
              return;
            }

            tabsSet.querySelectorAll('.js-tabs-prev');
            const currentCard = tabsSet.querySelector('.is-current');
            const newCard = tabs.item(i);
            const title = newCard.getAttribute('data-title');
            if (currentCard != null) {
              helpers.removeClass(currentCard, 'is-current');
            }
            helpers.addClass(newCard, 'is-current');

            tabsSet.querySelector('.js-tabs-current').innerText = title;

            if (tabsSet.hasAttribute('data-retain-page')) {
              sessionStorage.setItem(tabsSet.id, i);
            }

            updateNav(i);
          }

          function move(dir = 'next') {
            const currentCard = tabsSet.querySelector('.is-current');
            const len = tabs.length;
            let i = helpers.indexInParent(currentCard);

            if (dir === 'prev') {
              if (i - 1 < 0) return;
              i -= 1;
              // i = i < 0 ? 0 : i;
            } else {
              if (i + 1 >= len) return;
              i += 1;
            }

            goto(i);
          }

          tabsSet.querySelector('.js-tabs-prev').addEventListener('click', (e) => {
            e.preventDefault();
            move('prev');
          });

          tabsSet.querySelector('.js-tabs-next').addEventListener('click', (e) => {
            e.preventDefault();
            move('next');
          });

          // if the page is set in sessionStorage
          const page = sessionStorage.getItem(tabsSet.id);
          if (page && tabsSet.hasAttribute('data-retain-page')) {
            goto(parseInt(page, 10));
            return;
          }

          // If the current Card is set in markup then go to it, otherwise go to first
          const currentCard = tabsSet.querySelector('.is-current');
          if (currentCard != null) {
            const i = helpers.indexInParent(currentCard);
            goto(i);
          } else {
            goto(0);
          }
        });
      }
    },
  };
}());
